/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable no-unused-expressions */

import { ComboBox, Label, ResponsiveTable } from '@fitinsur/components';
import { Layout, Text } from 'components';
import DialogComponent from 'components/Dialog';
import {
  SelectField
} from 'components/Form';
import InputField from 'components/Form/InputField';
import HasPermission from 'components/HasPermission/index';
import ListEnquiryButtons from 'components/ListEnquiryButtons';
import Loader from 'components/Loader';
import NotesModalV2 from "components/NotesModalV2";
import Access from 'constants/Access';
import Colors from 'constants/Colors';
import { Field, Form, Formik, Form as Formikform } from 'formik';
import IMask from 'imask';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useGetQuoteList } from 'services/OperationService';
import useWindowScroll from 'services/useWindowScroll';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { CacheManager, FitinsurAPI, MessageCenter } from 'utils';
import MasksHelper from 'utils/src/masks';
import * as Yup from 'yup';
import ListHeader from './listHeader';
import {
  ButtonContainer,
  ContentAlert,
  ContentTextarea,
  DialogCancel,
  DialogConfirm,
  DialogRejected,
  DialogSelect,
  Textarea
} from './styles';
import { Content } from './styles_home';

export default function ListPage2(props) {
  const cache = new CacheManager();
  const masks = new MasksHelper();
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();

  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const history = useHistory();
  const location = useLocation();
  const lostReasonsRef = useRef();

  let filterFormik = useRef({});
  let formikRef = useRef({});
  let scrollUpdate = useWindowScroll();

  const [hasPermissionCreateFramework, setHasPermissionCreateFramework] = useState(false);
  const [listData, setListData] = useState([]);
  const [typeDialog, setTypeDialog] = useState(null);
  const [userComments, setUserComments] = useState("");
  const [lostDeal, setLostDeal] = useState({ formated: [], array: [] });
  const [dialog, setDialog] = useState({
    visible: false,
    title: '',
    icon: 'exclamation',
    args: null,
    field: null
  });
  const [headerStatus, setHeaderStatus] = useState([]);
  const [headerBroker, setHeaderBroker] = useState([]);
  const [headerProduct, setHeaderProduct] = useState([]);
  const [filtersList, setFiltersList] = useState([]);
  const [message, setMessage] = useState([null]);
  const [filterOptions, setFilterOptions] = useState([]);
  const [tooltips, setTooltips] = useState([]);
  const [filterSelected, setFilterSelected] = useState([null]);
  const [offices, setOffices] = useState([]);
  const [likelihoodOptions, setLikelihoodOptions] = useState([]);
  const [currentOperation, setCurrentOperation] = useState(null);
  const [fieldColumnsValue, setFieldColumnsValue] = useState([]);
  const [lastValues, setLastValues] = useState([]);
  const [sortBy, setSortBy] = useState({});
  const [filterString, setFilterString] = useState(null);
  const [showFilter, setShowFilter] = useState(false);

  const [paginationControls, setPaginationControls] = useState({
    "currentPage": 1,
    "numberMaxRecords": null,
    "total": null,
    "totalPages": null,
    "numberRecords": null
  });

  const [products, setProducts] = useState(
    [
      {
        label: "NO PRODUCTS",
        value: ""
      }
    ]
  );

  const columns = [
    {
      title: "REFERENCE",
      key: "reference",
      sortKey: "orderReferenceNumber",
      minWidth: 14,
      maxWidth: 14,
      color: (item) => handleColorLabel(item),
    },
    {
      title: "OFFICE",
      key: "leadingOffice",
      sortKey: "orderOffice",
      minWidth: 14,
      maxWidth: 14,
      color: (item) => handleColorLabel(item),
    },
    {
      title: "CLIENT",
      key: "nmClient",
      sortKey: "orderClient",
      minWidth: 14,
      maxWidth: 14,
      color: (item) => handleColorLabel(item),
    },
    {
      title: "MAIN PARTY",
      key: "projectName|nmObligor",
      sortKey: "orderObligor",
      minWidth: 14,
      maxWidth: 14,
      color: (item) => handleColorLabel(item),
    },
    {
      title: "BROKER",
      key: "nmBroker",
      sortKey: "orderBroker",
      minWidth: 14,
      maxWidth: 14,
      component: (listItem) => {
        const key = `${listItem.idOperation}-nmBroker`;
        const columnValue = fieldColumnsValue.find((column) => column?.name === `${listItem.idOperation}-nmBroker`);

        const customValue = columnValue?.value ?? listItem.idBroker ?? "";

        return (
          <Field
            topReduce
            list={true}
            component={ComboBox}
            style={{ width: "80%" }}
            name={key}
            onFocus={(value) => {
              handleLastValue(customValue, 'nmBroker', listItem.idOperation);
            }}
            placeholder={"SELECT BROKER"}
            placeholderColor={handleColorLabel(listItem)}
            initialValue={customValue}
            options={listItem.listBrokers || []}
            onChange={(a) => {
              const value = listItem.listBrokers.find((option) => option.value === a);
              handleInputColumn(value.value, listItem.idOperation, 'nmBroker')
              let obj = { ...listItem };
              obj.newValue = a;
              obj.key = key;
              selectBroker(obj);
            }}
          />
        )
      },
    },
    {
      title: "ENQUIRY RECEIVED DATE",
      key: "dueDate",
      sortKey: "orderResponseBy",
      minWidth: 14,
      maxWidth: 14,
      color: (item) => handleColorLabel(item),
    },
    {
      title: "ESTIMATED BINDING DATE",
      key: "estimatedBindingDate",
      sortKey: "orderEstimateBindingDate",
      minWidth: 14,
      maxWidth: 14,
      component: (listItem) => {
        const key = `${listItem.idOperation}-estimatedBindingDate`;
        const columnValue = fieldColumnsValue.find(column => column?.name === key);

        const idQuestionnaireAnswer = listItem.idQuestionnaireEstimatedBindingDate || null;
        const idOperation = listItem.idOperation || null;
        const customValue = columnValue?.value ?? listItem.estimatedBindingDate ?? "";

        return (
          <Field
            topReduce
            disabled={false}
            style={{ width: "80%" }}
            component={InputField}
            onFocus={(value) => {
              handleLastValue(customValue, 'estimatedBindingDate', idOperation);
            }}
            customValue={customValue}
            name={key}
            onChange={(value) => {
              const currentDate = new Date();
              const expiredYear = currentDate.getFullYear() + 20;
              const expiredMonth = currentDate.getMonth() + 1;
              const year = parseInt(value.split("/").at(1));
              const month = parseInt(value.split("/").at(0))
              if (expiredYear < year) {
                mc.error(`Please provide a valid date. Limit ${String(expiredMonth).padStart(2, '0')}/${expiredYear}.`);
                value = value.split("/").at() + '/';
                return;
              }
              if (expiredYear === year && expiredMonth < month) {
                mc.error(`Please provide a valid date. Limit ${String(expiredMonth).padStart(2, '0')}/${expiredYear}.`);
                value = value.split("/").at() + '/';
                return;
              }
              handleInputColumn(value, listItem.idOperation, "estimatedBindingDate")
            }}

            onBlur={(value) => {
              handleQuestionAnswer(value, idQuestionnaireAnswer, idOperation, 1882)
            }}
            mask={masks.getMonthYearMask()}
          />
        );
      },
    },
    {
      title: "1ST YEAR DP BROKERAGE USD",
      key: "estimatedYear1DpBrokerage",
      sortKey: "orderYear1DpBrokerage",
      minWidth: 14,
      maxWidth: 14,
      component: (listItem) => {
        const key = `${listItem.idOperation}-estimatedYear1DpBrokerage`;
        const columnValue = fieldColumnsValue.find((column) => column?.name === `${listItem.idOperation}-estimatedYear1DpBrokerage`);

        const idQuestionnaireAnswer = listItem.idQstEstimatedYear1DoBrokerage || null;
        const idOperation = listItem.idOperation || null;

        let customValue = columnValue?.value ?? listItem.estimatedYear1DpBrokerage ?? "";
        customValue = !!customValue ? applyCurrencyMask(customValue) : "";

        return (
          <Field
            style={{ width: "80%" }}
            //customValue={customValue}
            //onFocus={(value) => {
            //  handleLastValue(customValue, 'estimatedYear1DpBrokerage', idOperation);
            //}}
            name={key}
            component={InputField}
            topReduce
            onChange={(value) => handleInputColumn(value, idOperation, "estimatedYear1DpBrokerage")}
            onBlur={(value) => {
              const unmaskedValue = value.replace(/,/g, '');
              handleQuestionAnswer(unmaskedValue, idQuestionnaireAnswer, idOperation, 754);
            }}

            //mask={masks.getMask("currency", authContext.region, 2, 12, 999999999999.99, 0.0)}
            mask={masks.getMask("currency", authContext.region, 2, null, null, 0)}
            disabled={false}
          />
        );
      },
    },
    {
      title: "LIKELIHOOD OF BINDING",
      key: "likelihoodOfBinding",
      sortKey: "orderLikelihoodOfBinding",
      minWidth: 14,
      maxWidth: 14,
      color: (item) => handleColorLabel(item),
      component: (listItem) => {
        const key = `${listItem.idOperation}-likelihoodOfBinding`;
        const columnValue = fieldColumnsValue.find((column) => column?.name === `${listItem.idOperation}-likelihoodOfBinding`);

        const idQuestionnaireAnswer = listItem.idQuestionnaireLikelihood || null;
        const idOperation = listItem.idOperation || null;

        const customValue = columnValue?.value ?? listItem.likelihoodOfBinding ?? "";

        return (
          <Field
            topReduce
            list={true}
            component={ComboBox}
            style={{ width: "80%" }}
            name={key}
            placeholder={"SELECT A LIKELIHOOD"}
            placeholderColor={handleColorLabel(listItem)}
            initialValue={customValue}
            print={listItem.idOperation === 869376}
            options={listItem.likelihoodOptions || []}
            onFocus={(value) => {
              handleLastValue(customValue, 'likelihoodOfBinding', idOperation);
            }}
            onChange={(a) => {
              const value = listItem.likelihoodOptions.find((option) => option.value === a);
              handleInputColumn(value.value, listItem.idOperation, 'likelihoodOfBinding')

              handleQuestionAnswer(
                !!value ? value.label : null,
                idQuestionnaireAnswer,
                idOperation,
                1883,
                !!value ? value.value : null,
              )
            }}
          />
        );
      },
    },
    {
      title: "STATUS",
      key: "statusOperation",
      sortKey: "orderStatus",
      minWidth: 14,
      maxWidth: 14,
      color: (item) => handleColorLabel(item),
    },
    {
      title: "ACTION",
      key: "action",
      minWidth: 14,
      maxWidth: 14,
      paddingRight: 40,
      component: (listItem) => (
        <ListEnquiryButtons
          editRoute={checkOperationRoute}
          createCopy={handleCreateEnquiryCopy}
          listItem={listItem}
          isClient={isClient}
          createModalBody={(args, arg2) => createModalBody(args, arg2)}
          idOperation={listItem.idOperation}
          editPermission={props.permissions?.EDIT_ENQUIRY}
          setCurrentOperation={setCurrentOperation}
          authContextToken={authContext?.token}
          iconTooltips={tooltips}
          width={100}
          toDocument={() => history.push(`/broking/document-management/${listItem.idOperation}`)}
          icons={["edit", "clone", "approve", "decline", "note", "folder"]}
        />
      ),
    },
    {
      // title: "REQUEST LIMIT",
      // key: "requestLimit",
      // sortKey: "orderRequestLimit",
      // minWidth: 14,
      // maxWidth: 14,
      // color: (item) => handleColorLabel(item),
      // component: (listItem) => {
      //   if (!listItem.requestLimit) return <></>;

      //   return <Label color={handleColorLabel(listItem)}>{`${listItem.currency} ${applyCurrencyMask(listItem.requestLimit)}`}</Label>;
      // },
    }
  ];

  const isClient = authContext.enumProfile === 1;
  const region = authContext.region === 'en-GB' ? 'en' : 'en';

  const {
    data: getQuoteListData,
    loading: getQuoteListLoading,
    error: getQuoteListError,
    status: getQuoteListStatus,
    request: getQuoteListRequest,
  } = useGetQuoteList();

  useEffect(() => {
    if (getQuoteListLoading) {
      loading.start();
    } else {
      loading.stop();
    }
  }, [getQuoteListLoading])

  useEffect(() => {
    if (getQuoteListStatus === 200) {
      if (getQuoteListData?.pagination_control?.currentPage === 1) {
        setListData(getQuoteListData.ret_value);
      } else {
        setListData([...listData, ...getQuoteListData.ret_value]);
      }

      for (const listItem of getQuoteListData.ret_value) {
        const key = `${listItem.idOperation}-estimatedYear1DpBrokerage`;
        formikRef?.current?.setFieldValue(key, listItem.estimatedYear1DpBrokerage);
      }
    }
  }, [getQuoteListStatus])

  const goToQuotePage = () => {
    history.push('quote');
  };

  const goToLoginPage = () => {
    history.push('login');
  };

  const requestLostDealList = () => {

    fitinsur.requestLostDealList()
      .then((response) => {
        return response.json();
      })
      .then((data) => {

        if (data.ret_code !== 200) {
          return;
        }
        if (data.ret_value) {
          const lista = [];
          for (let index = 0; index < data.ret_value.length; index++) {
            lista.push({ label: data.ret_value[index].ANSWER_OPTION_DESCRIPTION, value: data.ret_value[index].ID_ANSWER_OPTION })

          }
          setLostDeal({ formated: lista, array: data.ret_value });

        }
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${requestLostDealList.name}\n` + error);
        console.error('fitGetLostReason - Error:', error);
        setLostDeal({ formated: [{ label: 'Error', value: '' }], array: [] });
      });
  }

  async function requestProductsList() {
    const response = await fitinsur
      .requestAccess("", "CREATE", Access.CREATE_FRAMEWORK, null, null, authContext.token)
      .then((response) => response.json())

    const hasPermission = response && response.ret_code === 200;

    fitinsur.requestProductsList()
      .then(x => x.json())
      .then(response => {
        if (response.ret_code !== 200) {
          return;
        }

        const options = response.ret_value
          .map(product => ({
            label: product.PRODUCT_NAME,
            value: product.ID_PRODUCT
          }))
          .filter(product => {
            if (product.value === 16 && !hasPermission) {
              return;
            } else {
              return product;
            }
          })
        setProducts(options);
      })
      .catch(error => console.log(error));

    setHasPermissionCreateFramework(hasPermission);
  }

  const requestStatusList = () => {
    fitinsur.requestStatusHeader()
      .then(x => x.json())
      .then(res => {
        if (res.ret_code !== 200) {
          mc.error("An error happened, please try again.");
          return;
        }
        const mappedOpt = res.ret_value.map(x => {
          return { label: x.description, value: x.id }
        })

        setHeaderStatus(mappedOpt);
      })
  }

  const requestBrokerHeaderList = () => {
    fitinsur.requestBrokerHeader()
      .then(data => data.json())
      .then(response => {
        if (response.ret_code === 200) {
          const mappedOpt = response.ret_value.map(data => ({ label: data.nmPersonBroker, value: data.ID_PERSON || data.idPersonUser }));
          setHeaderBroker(mappedOpt);
        } else {
          mc.error("An error happened, please try again.");
        }
      })
  }

  const selectBroker = (a) => {
    setTypeDialog('mc.errorBroker');
    setDialog({
      visible: true,
      title: 'Attention',
      icon: 'exclamation',
      args: a,
      field: null
    });
  }

  const newEnquiry = () => {
    setTypeDialog('selectProduct');
    setDialog({
      visible: true,
      title: 'Select product',
      icon: 'exclamation',
      args: null,
      field: null
    })
  }

  const createModalBody = async (context, argS) => {
    fitinsur.setAuthToken(authContext.token);
    await requestLostDealList();
    setTypeDialog(context === "lost" ? 'lostReason' : 'ApproveAnalysis');
    setDialog({
      visible: true,
      title: context === "lost" ? 'LOST DEAL' : 'STATUS ANALYSIS',
      icon: context === "lost" ? 'times-circle' : 'exclamation',
      args: argS,
      field: null
    })
  }

  const HandleLostSubmit = (selectedID, array, argsContext) => {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.updateQuoteEdit(argsContext.idOperation, selectedID.reasons).then(x => x.json()).then(res => {
      if (res.ret_code !== 200) {
        mc.error(res.ret_msg_details);
        return;
      }
      setDialog({ visible: false, title: null, icon: null, args: null, field: null });
      lostReasonsRef.current?.setFieldValue('reasons', '');
      handleFilter();
    })
  }

  function handleSortList(key, direction) {
    if (!key || key === 'action' || key === 'status') return;

    let sort = { [key]: direction };
    setSortBy(sort);
    let e = paginationControls;
    e.currentPage = 1;
    setPaginationControls(e);

    getQuoteListRequest(null, {
      ...sort,
      control: {
        currentPage: e.currentPage
      },
    });
  }

  const HandleApproveButton = (argsContext) => {
    handleFilter();
    fitinsur.requestQuoteApprove({ idOperation: argsContext.idOperation, txtAnswerOption: userComments }).then(x => x.json()).then(res => {
      if (res.ret_code !== 200) {
        mc.error(res.ret_msg_details);
        return;
      }
      setDialog({ visible: false, title: null, icon: null, args: null, field: null });
      handleFilter();
      setUserComments('');
    })
  }

  const HandleRejectButton = (argsContext) => {
    fitinsur.requestQuoteReject({ idOperation: argsContext.idOperation, txtAnswerOption: userComments }).then(x => x.json()).then(res => {
      if (res.ret_code !== 200) {
        mc.error(res.ret_msg_details);
        return;
      }
      setDialog({ visible: false, title: null, icon: null, args: null, field: null });
      handleListState();
      setUserComments('');
    })

  }

  const checkOperationRoute = (idOperation, idProduct, idDomainStatusDoc) => {
    fitinsur.setAuthToken(authContext.token);
    loading.start();

    fitinsur.requestQuoteEditNavigation(idOperation).then(x => x.json()).then(res => {
      if (res.ret_code !== 200) {
        mc.error(res.ret_msg_details);
        return;
      }
      let route;
      const idOperationParent = res.ret_value.idOperationParent;
      switch (res.ret_value.idNavigation) {
        case 1:
          route = `/edit-enquirity/${idProduct}/${idOperation}${idOperationParent ? `/${idOperationParent}` : ""}`;
          break;
        case 2:
          route = `/edit-enquirity/${idProduct}/${idOperation}${idOperationParent ? `/${idOperationParent}` : ""}`;
          break;
        case 3:
          route = `/broking/approval-nbi/${idOperation}`;
          break;
        case 4:
          if (idProduct == "16") {
            route = `/broking/select-markets/${idOperation}/${idProduct}`;
          } else {
            route = `/broking/select-markets/${idOperation}`;
          }
          break;
        case 5:
          route = `/broking/contacts-selection/${idOperation}`;
          break;
        case 6:
          route = `/broking/nbi-request/${idOperation}`;
          break;
        case 7:
          route = `/broking/send-nbi-request/${idOperation}`;
          break;
        case 8:
          route = `/broking/market-selection/${idOperation}`;
          break;
        case 9:
          route = `/broking/document-nbi-status/${idOperation}`;
          break;
        case 10:
          route = `/broking/approval-nbi-cv/${idOperation}`;
          break;
        case 11:
          route = `/broking/nbi-request-cv/${idOperation}`;
          break;
        case 12:
          route = `/broking/market-composition/${idOperation}`;
          break;
        case 13:
          route = `/broking/policy-pack-approval/${idOperation}`;
          break;
        case 14:
          route = `/broking/approval-policy-pack/${idOperation}`;
          break;
        case 15:
          route = `/broking/send-policy-pack-client/${idOperation}`;
          break;
        case 16:
          route = `/broking/send-approval-pack/${idOperation}`;
          break;
        case 17:
          route = `/broking/send-order-to-bind/${idOperation}`;
          break;
        case 18:
          route = `/broking/order-to-bind/${idOperation}`;
          break;
        case 19:
          route = `/broking/order-to-bind/${idOperation}`;
          break;
        case 20:
          route = `/broking/stamps-status-list/${idOperation}`;
          break;
        case 21:
          route = `/broking/payment-pack-send-approval/${idOperation}`;
          break;
        case 22:
          route = `/broking/payment-pack-send-client-insurer/${idOperation}`;
          break;
        case 23:
          route = `/broking/payment-pack-approval/${idOperation}`;
          break;
        case 24:
          route = `/broking/send-nbi-cv/${idOperation}`;
          break;
        case 25:
          route = `/edit-master-policy/${idProduct}/${idOperation}`;
          break;
        case 26:
          route = `/broking/send-approval-pack/${idOperation}`;
          break;
        case 99:
          route = `/edit-enquirity/${idProduct}/${idOperation}${idOperationParent ? `/${idOperationParent}` : ""}`;
          break;
        default:
          route = '/home';
          break;
      }
      if (route) {
        loading.stop();
        history.push(
          {
            pathname: route,
            state: res.ret_value.idNavigation == 99 ? { disabled: true, idProduct: idProduct } : { status: idDomainStatusDoc, idProduct: idProduct }
          })
      } else {
        mc.error('NAVIGATION NOT DEFINED');
        loading.stop();
      }
    }).catch(() => loading.stop());
  }

  const handleCreateEnquiryCopy = (idProduct, idOperation) => {
    fitinsur.setAuthToken(authContext.token);
    loading.start();

    if (Number(idProduct) === 16) {
      fitinsur.requestQuoteEditNavigation(idOperation)
        .then(data => data.json()).then(res => {
          if (res.ret_code !== 200) {
            mc.error(res.ret_msg_details);
            loading.stop();
            return;
          }

          const { idOperationRoot } = res.ret_value;

          fitinsur.requestCreateEndorsement(idOperationRoot, 'declaration')
            .then(response => response.json())
            .then(data => {
              loading.stop();
              if (data.ret_code !== 200) {
                mc.error(data.ret_msg_details);
                return;
              }

              const newIdOperation = data.ret_value.idOperation;

              history.push(`/create-enquirity/${idProduct}/${newIdOperation}?refOperation=${idOperation}`)
            }).catch(() => loading.stop());
        }).catch(() => loading.stop());
    } else {
      loading.stop();
      history.push(`/create-enquirity/${idProduct}?refOperation=${idOperation}`)
    }
  }

  const handleNewEnquiry = () => {
    return <HasPermission permission={props.permissions.CREATE_ENQUIRY}>
      <Text primary
        type="button"
        id="btnSubmit"
        style={{ cursor: 'pointer' }}
        onClick={newEnquiry}>
        + NEW ENQUIRY
      </Text>
    </HasPermission>
      ;
  }

  const handleListState = (page = 1, filterQueryString = '?', sort) => {
    loading.start();
    fitinsur.setAuthToken(authContext.token);

    const filterString = filterQueryString ? filterQueryString : '?'

    const url = `${filterString}&requestPage=${page}`

    fitinsur.requestListAction(url, { sort })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (Array.isArray(data)) {
          loading.stop();
          return;
        }

        if (data.ret_code !== 200) {
          setListData([]);
          return;
        }

        if (data.ret_value?.length > 0) {
          setListData([]);
          const lista = [];
          for (let index = 0; index < data.ret_value.length; index++) {
            let element = data.ret_value[index];
            if (Array.isArray(element.listBrokers)) {
              element.listBrokers.forEach(element => {
                element.label = element.nmPersonBroker;
                element.value = element.idPersonUser
              });
              element.listBrokers.sort((first, next) => String(first.label).localeCompare(String(next.label)))
            } else {
              element.listBrokers = [{ value: '', label: element.nmObligor }]
            }
            lista.push(element);
          }
          const pagination = { ...data.pagination_control };

          for (const listItem of lista) {
            const key = `${listItem.idOperation}-estimatedYear1DpBrokerage`;
            formikRef?.current?.setFieldValue(key, listItem.estimatedYear1DpBrokerage);
          }

          if (+pagination.currentPage === 1) {
            setListData(lista)
          } else {
            setListData([...listData, ...lista]);
          }

          pagination.currentPage = parseInt(pagination.currentPage);
          setPaginationControls(pagination);
          setTimeout(() => loading.stop(), 1000);
        } else {
          setListData([]);
          loading.stop();
        }

        setOffices(data.offices);

        setLikelihoodOptions(data.likelihoodOptions);

        loading.stop();
      })
      .catch((error) => {
        console.error('handleListState - Error:', error);
        loading.stop();
      });
  }

  const jsonToQueryString = (json) => {
    const keys = Object.keys(json).filter(key => json[key]);

    return keys
      .map((key, index) => {
        const sufix = index + 1 === keys.length
          ? ''
          : '&'

        return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]) + sufix;
      }
      ).join('');
  }

  const handleFilter = (filters = {}) => {
    loading.start();
    let dtResponseByRange = {};

    if (filters?.dtResponseBy?.from && filters?.dtResponseBy?.to) {
      dtResponseByRange = {
        dtResponseByFrom: new Date(filters.dtResponseBy.from).toLocaleDateString('en-US'),
        dtResponseByTo: new Date(filters.dtResponseBy.to).toLocaleDateString('en-US'),
      }
    }

    const { dtResponseBy, ...rest } = filters;

    const queryString = jsonToQueryString({
      ...rest,
      ...dtResponseByRange,
    })

    const filterQueryString = `?${queryString}`;

    fitinsur.setAuthToken(authContext.token);
    handleListState(1, filterQueryString)

    if (queryString) {
      setFilterString(filterQueryString)
      localStorage.setItem('enquiries_filter_texel', filterQueryString)
    } else {
      localStorage.removeItem('enquiries_filter_texel')
    }

    history.push(`enquiries${filterQueryString}`)
  }

  const handleSetFilterFromParams = () => {
    if (location.search) {
      const query = new URLSearchParams(location.search);

      if (query.get('nmClient')) {
        filterFormik.current?.setFieldValue('nmClient', query.get('nmClient'))
      }

      if (query.get('nmObligor')) {
        filterFormik.current?.setFieldValue('nmObligor', query.get('nmObligor'))
      }

      if (query.get('idBroker')) {
        let brokerIds = query
          .get('idBroker')
          .split(',')
          .map(item => Number(item))


        filterFormik.current?.setFieldValue('idBroker', brokerIds)
      }
      if (query.get('idProduct')) {
        let brokerIds = query
          .get('idProduct')
          .split(',')
          .map(item => Number(item))


        filterFormik.current?.setFieldValue('idProduct', brokerIds)
      }

      if (query.get('idProduct')) {
        let brokerIds = query
          .get('idProduct')
          .split(',')
          .map(item => Number(item))


        filterFormik.current?.setFieldValue('idProduct', brokerIds)
      }

      if (query.get('likelihoodOfBinding')) {
        let likelihoodOptionsIds = query
          .get('likelihoodOfBinding')
          .split(',')
          .map(item => Number(item))


        filterFormik.current?.setFieldValue('likelihoodOfBinding', likelihoodOptionsIds)
      }

      if (query.get('idProduct')) {
        let brokerIds = query
          .get('idProduct')
          .split(',')
          .map(item => Number(item))


        filterFormik.current?.setFieldValue('idProduct', brokerIds)
      }

      if (query.get('idStatus')) {
        let statusIds = query
          .get('idStatus')
          .split(',')
          .map(item => Number(item))

        filterFormik.current?.setFieldValue('idStatus', statusIds)
      }

      if (query.get('dtResponseByFrom') && query.get('dtResponseByTo')) {
        filterFormik.current?.setFieldValue('dtResponseBy', {
          from: new Date(query.get('dtResponseByFrom')),
          to: new Date(query.get('dtResponseByTo')),
        })
      }

      if (query.get('dsReferenceNumber')) {
        filterFormik.current?.setFieldValue('dsReferenceNumber', query.get('dsReferenceNumber'))
      }

      if (query.get('leadingOffice')) {
        let officesIds = query
          .get('leadingOffice')
          .split(',')
          .map(item => Number(item))

        filterFormik.current?.setFieldValue('leadingOffice', officesIds)
      }


      if (query.get('estimatedBindingDate')) {
        filterFormik.current?.setFieldValue('estimatedBindingDate', query.get('estimatedBindingDate'))
      };

      if (query.get('estimatedYear1DpBrokerage')) {
        filterFormik.current?.setFieldValue('estimatedYear1DpBrokerage', query.get('estimatedYear1DpBrokerage'));
      }

      if (query.get('requestLimit')) {
        filterFormik.current?.setFieldValue('requestLimit', query.get('requestLimit'))
      }

      if (query.get('hideInactiveTransactions')) {
        filterFormik.current?.setFieldValue('hideInactiveTransactions', true)
      }

      if (query.get('hideExecutedTransactions')) {
        filterFormik.current?.setFieldValue('hideExecutedTransactions', true)
      }

      if (query.get('idAction')) {
        let actionIds = query
          .get('idAction')
          .split(',')
          .map(item => Number(item))

        filterFormik.current?.setFieldValue('idAction', actionIds)
      }
    }
  }

  const handleGetPreviusFilter = () => {
    const filterQueryString = localStorage.getItem('enquiries_filter_texel');

    if (filterQueryString) {
      history.push(`enquiries${filterQueryString}`)
      handleListState(1, filterQueryString)

    } else {
      handleListState()
    }
  }

  const handleExportQuotes = async (page = 1, filterQueryString = '?') => {
    let exportList = sessionStorage.getItem('texel-export-list-report');
    let list = [];
    if (exportList) list = JSON.parse(sessionStorage.getItem('texel-export-list-report'))
    let verify = list.length > 0 ? list.filter(item => item.nameList == 'Enquiry Report') : false;
    if (!verify || verify.length == 0) {
      loading.start();
      setTimeout(() => loading.stop(), 2000);
      const url = `${filterQueryString}&requestPage=${page}`;
      fitinsur.setAuthToken(authContext.token);
      const document = await fitinsur.exportQuotes(url).then(x => x.json());
      loading.start();
      setTimeout(() => loading.stop(), 2000);
      if (document.idDocument) {
        list.push({ idDocument: document.idDocument, processing: true, nameList: 'Enquiry Report' });
        sessionStorage.setItem('texel-export-list-report', JSON.stringify(list));
      }
    } else {
      mc.error("Please, wait claim report be downloaded.");
    }
  }

  const editCustomFilter = (filter) => {
    if (filter.nmFilter.length <= 0) return mc.error("Filter name must be provided");
    const obj = {
      filterName: filter.nmFilter,
      id: filter.id,
      idDomain: 318,
      idDomainApplication: 388,
      filterArgs: {
        nmClient: filter.nmClient,
        orderClient: filter.orderClient,
        nmObligor: filter.nmObligor,
        orderObligor: filter.orderObligor,
        idBroker: filter.idBroker,
        likelihoodOfBinding: filter.likelihoodOfBinding,
        idProduct: filter.idProduct,
        orderBroker: filter.orderBroker,
        idStatus: filter.idStatus,
        orderStatus: filter.orderStatus,
        dtResponseBy: {
          from: filter.dtResponseBy.from,
          to: filter.dtResponseBy.to,
        },
        orderResponseBy: filter.orderResponseBy,
        dsReferenceNumber: filter.dsReferenceNumber,
        orderReferenceNumber: filter.orderReferenceNumber,
        estimatedBindingDate: filter.estimatedBindingDate,
        idAction: filter.idAction,
        orderOffice: filter.orderOffice,
        leadingOffice: filter.leadingOffice,
        estimatedYear1DpBrokerage: filter.estimatedYear1DpBrokerage,
        requestLimit: filter.requestLimit,
        hideInactiveTransactions: filter.hideInactiveTransactions,
        hideExecutedTransactions: filter.hideExecutedTransactions
      }
    }
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestUpdateCustomFilter(obj)
      .then(x => x.json())
      .then(res => {
        if (res.ret_code !== 200) {
          mc.error("An error happened, please try again.");
          return;
        }
        mc.success('Custom filter updated!')
        requestCustomFilterList('edit')
      })
  }

  const createCustomFilter = (filter) => {
    if (!filter.nmFilter) {
      mc.error("Please provide a name.");
      return;
    }
    const obj = {
      filterName: filter.nmFilter,
      idDomain: 318,
      idDomainApplication: 388,
      filterArgs: {
        nmClient: filter.nmClient,
        orderClient: filter.orderClient,
        nmObligor: filter.nmObligor,
        orderObligor: filter.orderObligor,
        idBroker: filter.idBroker,
        likelihoodOfBinding: filter.likelihoodOfBinding,
        idProduct: filter.idProduct,
        orderBroker: filter.orderBroker,
        idStatus: filter.idStatus,
        orderStatus: filter.orderStatus,
        dtResponseBy: {
          from: filter.dtResponseBy.from,
          to: filter.dtResponseBy.to,
        },
        orderResponseBy: filter.orderResponseBy,
        dsReferenceNumber: filter.dsReferenceNumber,
        orderReferenceNumber: filter.orderReferenceNumber,
        idAction: filter.idAction,
        orderOffice: filter.orderOffice,
        estimatedBindingDate: filter.estimatedBindingDate,
        estimatedYear1DpBrokerage: filter.estimatedYear1DpBrokerage,
        requestLimit: filter.requestLimit,
        leadingOffice: filter.leadingOffice,
        hideInactiveTransactions: filter.hideInactiveTransactions,
        hideExecutedTransactions: filter.hideExecutedTransactions
      }
    }
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestCreateCustomFilter(obj)
      .then(x => x.json())
      .then(res => {
        if (res.ret_code !== 200) {
          mc.error("An error happened, please try again.");
          return;
        }
        mc.success('Filter created successfully')
        requestCustomFilterList('create')
      })
  }

  const deleteCustomFilter = (selectedFilter) => {
    if (selectedFilter.filterName !== 'DEFAULT') {
      const obj = {
        filterName: selectedFilter.filterName,
        id: selectedFilter.id,
        idDomain: selectedFilter.idDomain,
        idDomainApplication: selectedFilter.idDomainApplication,
      }
      fitinsur.setAuthToken(authContext.token);
      fitinsur.requestDeleteCustomFilter(obj)
        .then(x => x.json())
        .then(res => {
          if (res.ret_code !== 200) {
            mc.error("An error happened, please try again.");
            return;
          }
          mc.success('successfully deleted filter')
          setShowFilter(false)
          requestCustomFilterList('delete')
        })
    } else {
      mc.error("This filter cannot be removed!")
    }
  }

  const requestCustomFilterList = (action) => {



    const obj = {
      idDomain: 318,
      idDomainApplication: 388
    }

    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestGetCustomFilter(obj)
      .then(x => x.json())
      .then(res => {
        if (res.ret_code !== 200) {
          mc.error("An error happened, please try again.");
          return;
        }
        const enquiryFilterList = res.ret_value.filter(
          element => {
            return element.idDomain === 318 && element.idDomainApplication === 388
          }
        )
        const option = []
        enquiryFilterList.map((element, index) => {
          let opt = {
            label: element.filterName,
            value: index
          }
          option.push(opt)
        })
        setFilterOptions(option)
        setFiltersList(enquiryFilterList)
        setFilterSelected(enquiryFilterList[0])
        const query = new URLSearchParams(location.search);
        let name = query.get('nmFilter')
        let index = option.find(option => option.label === name)?.value
        if (action === 'search' || action === 'load' || name) {
          const value = {
            id: index,
            filterName: name,
            nmClient: "",
            orderClient: 0,
            nmObligor: "",
            orderObligor: 0,
            idBroker: "",
            likelihoodOfBinding: "",
            idProduct: "",
            orderBroker: 0,
            idStatus: "",
            orderStatus: 0,
            dtResponseBy: {
              from: null,
              to: null,
            },
            orderResponseBy: 0,
            dsReferenceNumber: "",
            orderReferenceNumber: 0,
            estimatedBindingDate: "",
            requestLimit: "",
            idAction: "",
            orderOffice: 0,
            leadingOffice: "",
            hideInactiveTransactions: false,
            hideExecutedTransactions: false

          };
          setFilterSelected(value)
        } if (action === 'create') {
          const filterCreated = option[option.length - 1]
          // formik.current?.setFieldValue("filtersList", filterCreated.value);
          const value = {
            id: index,
            filterName: filterCreated.label,
            nmClient: "",
            orderClient: 0,
            nmObligor: "",
            orderObligor: 0,
            idBroker: "",
            likelihoodOfBinding: "",
            idProduct: "",
            orderBroker: 0,
            idStatus: "",
            orderStatus: 0,
            dtResponseBy: {
              from: null,
              to: null,
            },
            orderResponseBy: 0,
            dsReferenceNumber: "",
            orderReferenceNumber: 0,
            idAction: "",
            orderOffice: 0,
            leadingOffice: "",
            estimatedYear1DpBrokerage: "",
            requestLimit: "",
            hideInactiveTransactions: false,
            hideExecutedTransactions: false
          };
          setFilterSelected(value)
        } if (action === 'load' && !name || action === 'reset') {
          setFilterSelected(enquiryFilterList[0])
        }
      })
  }

  useEffect(() => {
    if (authContext.status !== true) {
      mc.error("User is not authenticated, please Login");
      goToLoginPage();
    } else {
      fitinsur.setAuthToken(authContext.token);
      requestProductsList();
      requestStatusList();
      requestBrokerHeaderList();
      requestCustomFilterList('load');


      if (location.search) {
        handleSetFilterFromParams()
        handleListState(1, location.search);
      } else {
        handleGetPreviusFilter();
      }

      if (location.search) {
        handleSetFilterFromParams()
        handleListState(1, location.search);
      } else {
        handleGetPreviusFilter();
      }
    }
    setLostDeal({ formated: [], array: [] });
    cache.getTooltip("DOMAINS", region, "357", [585, 586, 587, 581, 583, 584, 602], authContext.token).then(msg => {
      let obj = [];
      msg.map(element => {
        obj[element.MODEL_ITEM_ID] = element.MSG_TEXT;
      })
      setTooltips(obj)
    }).catch(err => console.log("error", err));
    cache.getMessage("NO_ITEMS_LIST", region, "355", authContext.token).then(msg => setMessage(msg)).catch(err => console.log("error", err));
  }, []);

  const handleColorLabel = (item) => {
    if (item.isRejected) return Colors.GRAY[3];
    else if (item.requireAttention) return Colors.RED;
    else if (item.isApproved) return Colors.GRAY[0];
    else if (item.mediationFinished) return Colors.PRIMARY1;
    else return Colors.GRAY[0];
  }

  const handleLastValue = (lastValue, column, idOperation) => {
    const lastValuesDict = Object.fromEntries(
      lastValues.map(value => [value.key, value])
    );

    const key = `${idOperation}-${column}`;
    lastValuesDict[key] = { key, lastValue };
    const updatedLastValues = Object.values(lastValuesDict);

    setLastValues(updatedLastValues);
  }

  const handleInputColumn = (value, idOperation, column) => {
    const fieldColumnsValueDict = Object.fromEntries(
      fieldColumnsValue.map(date => [date.name, date])
    );

    const key = `${idOperation}-${column}`;
    fieldColumnsValueDict[key] = { name: key, value };
    const updatedFieldColumnsValue = Object.values(fieldColumnsValueDict);

    setFieldColumnsValue(updatedFieldColumnsValue);
  };

  const resetFieldColumnsValue = () => {
    const { key, idOperation } = dialog.args;
    const lastValue = lastValues.find((lastValue) => lastValue.key === key).lastValue;
    handleInputColumn(lastValue, idOperation, key.split('-')[1])
  }

  function handleQuestionAnswer(value, idQuestionnaireAnswer, idOperation, idQuestion, idAnswerOption) {
    loading.start();
    let textAnswer = value;
    let body = {
      idQuestion,
      textAnswer,
      idOperation,
      idAnswerOption,
    };

    if (idQuestionnaireAnswer) {
      body.idQuestionnaireAnswer = idQuestionnaireAnswer;

      fitinsur.setAuthToken(authContext.token);
      fitinsur.updateQuestionnaireAnswer(body)
        .then((x) => x.json())
        .then((obj) => {
          if (obj.ret_code !== 200) {
            mc.error("An error happened, please try again");
            return;
          }
        })
        .catch((e) => {
          mc.error("An error happened, please try again");
        })
        .finally(() => loading.stop());
    } else {
      fitinsur.setAuthToken(authContext.token);
      fitinsur.insertQuestionnaireAnswer(body)
        .then((x) => x.json())
        .then((obj) => {
          if (obj.ret_code !== 200) {
            mc.error("An error happened, please try again");
            return;
          }
        })
        .catch((e) => {
          mc.error("An error happened, please try again");
        })
        .finally(() => loading.stop());
    }
  }

  const applyCurrencyMask = (value) => {
    const currencyMask = masks.getMask("currency", authContext.region, 2, 12, 999999999999.99, 0.0)
    const mask = IMask.createMask(currencyMask)
    mask.resolve(value)
    return mask.value
  }

  useEffect(() => {
    if (scrollUpdate && paginationControls.currentPage < paginationControls.totalPages) {
      if (!loading.active) {
        loadPage();
      }
    }
  }, [scrollUpdate])

  function loadPage() {
    let e = paginationControls;
    e.currentPage++;
    setPaginationControls(e);

    fitinsur.setAuthToken(authContext.token);
    if (location.search) {
      handleListState(e.currentPage, location.search)
    } else {
      handleListState(e.currentPage)
    }
  }

  return (
    <>
      <Layout title={'Enquiry List'} subtitle={handleNewEnquiry()} id='page'>
        {false && handleNewEnquiry()}
        <Content>
          <ListHeader
            formikRef={ref => filterFormik.current = ref?.current}
            status={headerStatus}
            broker={headerBroker}
            products={products}
            filtersList={filtersList}
            updateFilter={(filters) => handleFilter(filters)}
            onShowFilter={(showFilter) => setShowFilter(showFilter)}
            handleExportQuotes={() => handleExportQuotes(1, location.search || undefined)}
            editCustomFilter={(values) => editCustomFilter(values)}
            createCustomFilter={(values) => createCustomFilter(values)}
            deleteCustomFilter={(values) => deleteCustomFilter(values)}
            requestCustomFilterList={(values) => requestCustomFilterList(values)}
            defaultFilter={filterSelected}
            options={filterOptions}
            iconTooltips={tooltips}
            offices={offices}
            likelihoodOptions={likelihoodOptions}
            location={location}
          />

          <NotesModalV2
            show={currentOperation}
            handleClose={() => { setCurrentOperation(null) }}
            idOperation={currentOperation}
            label={'Enquiry notes'}
            onChange={(idOperation, requireAttention) => {
              setListData(listData.map((enquiry) => {
                if (idOperation == enquiry.idOperation) {
                  enquiry.requireAttention = requireAttention;
                }
                return enquiry;
              }))
            }}
          />

          <DialogComponent icon={dialog.icon} title={dialog.title} show={dialog.visible} setDialog={setDialog}>
            {typeDialog == 'selectProduct' ?
              <Formik
                initialValues={{ product: '' }}
                validationSchema={Yup.object().shape({ product: Yup.string().required("* Required field") })}
                onSubmit={route => {

                  if (route.product !== 16) return history.push(`create-enquirity/${route.product}`)

                  if (route.product === 16 && hasPermissionCreateFramework) {
                    history.push(`create-master-policy/${route.product}`)
                  } else {
                    mc.error("This user doesn't have permission to execute this action");
                  }

                }}
                render={({ values, setFieldValue }) => (
                  <Form>
                    <DialogSelect>
                      <Field
                        name="product"
                        value={values.product}
                        onChange={e => { setFieldValue('product', e) }}
                        placeholder="Select product"
                        component={SelectField}
                        options={products}
                      />
                    </DialogSelect>
                    <DialogCancel onClick={(e) => { e.stopPropagation(); e.preventDefault(); setDialog({ visible: false, title: null, icon: null, args: null, field: null }) }}>Cancel</DialogCancel>
                    <DialogConfirm type="submit">Confirm</DialogConfirm>
                  </Form>
                )}>
              </Formik>
              : typeDialog === 'mc.errorBroker' ?
                <ContentAlert>
                  <p>You are about to change the "BROKER" in this deal, are you sure?</p>
                  <DialogCancel onClick={() => {
                    resetFieldColumnsValue();
                    setDialog({ visible: false, title: null, icon: null, args: null, field: null });
                  }}>Cancel</DialogCancel>
                  <DialogConfirm onClick={() => {
                    loading.start();
                    let brokerA = dialog.args.listBrokers.find(x => x.idPersonUser === dialog.args.newValue);
                    let body = {
                      idOperation: dialog.args.idOperation,
                      idPerson: brokerA.idPersonUser,
                      personFirstName: brokerA.personFirstNameUser,
                      personLastName: brokerA.personLastNameUser
                    }
                    fitinsur.setAuthToken(authContext.token);
                    fitinsur.changeBrokerList(body).then(x => x.json()).then(obj => {
                      if (obj.ret_code !== 200) {
                        mc.error("An error happened, please try again");
                        return;
                      }
                      setDialog({ visible: false, title: null, icon: null, args: null, field: null });
                    }).catch(e => {
                      mc.error("An error happened, please try again");
                      return;
                    }).finally(() => loading.stop());
                  }}>Confirm</DialogConfirm>
                </ContentAlert>
                : typeDialog === 'lostReason' ?
                  <Formik initialValues={{ reasons: '' }} innerRef={lostReasonsRef} onSubmit={(e) => { HandleLostSubmit(e, lostDeal.array, dialog.args); }}>
                    <Formikform>
                      <DialogSelect>
                        <Field
                          name="reasons"
                          placeholder="Select the reason the deal was lost"
                          component={SelectField}
                          options={lostDeal.formated}
                        />

                      </DialogSelect>
                      <DialogCancel onClick={(e) => { e.stopPropagation(); e.preventDefault(); setDialog({ visible: false, title: null, icon: null, args: null, field: null }); lostReasonsRef.current?.setFieldValue('reasons', ''); }}>Cancel</DialogCancel>
                      <DialogConfirm type="submit">Confirm</DialogConfirm>
                    </Formikform>
                  </Formik>
                  : typeDialog == 'ApproveAnalysis' ?
                    <ContentTextarea>
                      <p>Deal Analysis information</p>
                      <Textarea value={userComments} onChange={(e) => { setUserComments(e.target.value) }}></Textarea>
                      <DialogRejected onClick={() => HandleRejectButton(dialog.args)}>Rejected</DialogRejected>
                      <DialogConfirm onClick={() => HandleApproveButton(dialog.args)}>Approved</DialogConfirm>
                    </ContentTextarea>
                    : ''
            }
          </DialogComponent>

          <Formik
            innerRef={formikRef}
            initialValues={{}}
            validationSchema={Yup.object({})}
            onSubmit={values => {
              goToQuotePage();
            }}
          >
            <Form style={{ minHeight: showFilter ? '450px' : '' }}>
              {false && handleNewEnquiry()}
              <ResponsiveTable onSortTable={handleSortList} formikRef={filterFormik?.current} columns={columns} data={listData} />

              {!listData.length && < ButtonContainer style={{ minHeight: showFilter ? '450px' : '' }}>
                <Text style={{ fontWeight: 'bold', color: Colors.GRAY[1], margin: 'auto', cursor: 'pointer', marginTop: '10px' }} onClick={() => { }}>{message}</Text>
              </ButtonContainer>}
            </Form>
          </Formik>

          {loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}

          {
            paginationControls.currentPage < paginationControls.totalPages ? (
              <ButtonContainer>
                <Text primary
                  type="button"
                  id="btnSubmit"
                  style={{ fontWeight: 'bold', color: Colors.GRAY[1], margin: 'auto', cursor: 'pointer', marginTop: '10px' }}
                  onClick={() => {
                    loadPage()
                  }}>
                  +LOAD MORE ACCOUNTS
                </Text>
              </ButtonContainer>
            ) : ''
          }
        </Content>
      </Layout>
    </>
  );
}
